import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import withConfig from '@/config/withConfig';
import {withHeadComponent} from 'hooks/use-head-component';
import {useCurrentPathname} from 'hooks/use-current-pathname';

const ROUTES_WITH_OWN_TITLE = ['/search'];

export const ApplicationMeta = ({
    appStoreLink,
    metaLogoUrl,
    playStoreLink,
    isDeployed,
    HeadComponent,
}) => {
    const pathname = useCurrentPathname();
    const hasOwnTitle = ROUTES_WITH_OWN_TITLE.includes(pathname);

    return (
        <HeadComponent>
            <meta charSet="utf-8" />
            {!hasOwnTitle && (
                <>
                    <meta
                        name="description"
                        itemProp="description"
                        content="Find, book & save on both daily & monthly parking with convenient garages, lots & valets near your destination."
                    />
                    <meta name="robots" content="noodp, noydir" />
                </>
            )}
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@spothero" />
            <meta name="twitter:creator" content="@spothero" />
            <meta name="twitter:app:id:iphone" content="499097243" />
            <meta name="twitter:app:url:iphone" content={appStoreLink} />
            <meta name="twitter:app:name:ipad" content="SpotHero" />
            <meta name="twitter:app:url:ipad" content={appStoreLink} />
            <meta
                name="twitter:app:id:googleplay"
                content="com.spothero.spothero"
            />
            <meta name="twitter:app:url:googleplay" content={playStoreLink} />
            {isDeployed && (
                <meta
                    name="google-site-verification"
                    content="xoYVsdp3bXNxwds_Sw1C46aJ_9pJ0tQOXI3bxgBGyfQ"
                />
            )}
            {isDeployed && (
                <meta
                    name="msvalidate.01"
                    content="E44412335167C2135871BD45A0A0B36C"
                />
            )}
            <meta property="og:type" content="website" />
            <meta property="og:image" content={metaLogoUrl} />
            <meta property="og:site_name" content="SpotHero" />
            {!hasOwnTitle && (
                <title>
                    SpotHero - Park Smarter. | Reserve Parking Now &amp; Save
                </title>
            )}
        </HeadComponent>
    );
};

ApplicationMeta.propTypes = {
    appStoreLink: PropTypes.string.isRequired,
    metaLogoUrl: PropTypes.string.isRequired,
    playStoreLink: PropTypes.string.isRequired,
    isDeployed: PropTypes.bool.isRequired,
    HeadComponent: PropTypes.elementType,
};

// Only overridden (via withHeadComponent, applied below) when rendering in
// the legacy app, where Helmet is the head manager actually wired up
// instead of next/head.
ApplicationMeta.defaultProps = {
    HeadComponent: Head,
};

export default withHeadComponent(
    withConfig(['appStoreLink', 'isDeployed', 'metaLogoUrl', 'playStoreLink'])(
        ApplicationMeta
    )
);
